import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            companies: [],
            showQrCodeItem: null,
        }
    },
    methods: {
        load: load,
        editCompany: editCompany,
        addCompany: addCompany,
        showQrCodeForItem: showQrCodeForItem,
        deleteCompany: deleteCompany
    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.role = session.getRole();
        this.load()
    },
    created() {
        let _self = this;
        this.$topnavbar.$on('closeShowQrCode', () => {
            _self.showQrCodeItem = null;
        });
    }
}

function showQrCodeForItem(item){
    this.showQrCodeItem = {
        orderUuid: item.uuid,
        name: item.name
    }
}


function load() {
    let _self = this;

    AdminApiService.getCompanyPartners()
        .then((response) => {
            _self.companies = response.data
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function deleteCompany(company){
    let _self = this;

    swal({
        title: LocService.t('label_are_you_sure_delete_partner'),
        text: LocService.t('label_are_you_sure_delete_partner_desc') + ": " + company.name +"?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteCompanyPartner(company.id)
            .then((response) => {
                swal(LocService.t('label_success'), LocService.t('label_partner_success_delete'), 'success')
                _self.load();
            })
            .catch(error => {
                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });


}

function editCompany(company) {
    this.$router.push('/add-company-partner?id=' + company.id + '&name='+company.name + '&maxNumberOfUsers=' + company.maxNumberOfUsers)
}

function addCompany() {
    this.$router.push('/add-company-partner')
}


// WEBPACK FOOTER //
// ./src/components/CompanyPartner/CompanyPartner.js